import { useEffect,useState } from "react";
const useGroup = ()=>{
    const [col,setCol] = useState(4);
    const [space,setSpace] = useState(10);
    window.addEventListener('resize',handleSize)

    function handleSize() {

        if(window.innerWidth>640&&window.innerWidth<1024){
            setCol(4);
        }
        else if(window.innerWidth>=1024){
            setCol(5)
        }
        else{
            setCol(3);
        }
    }
    
    useEffect(()=>{
        if(window.innerWidth>640&&window.innerWidth<1024){
            setCol(4);
            setSpace(10)
        }
        else if(window.innerWidth>=1024){
            setCol(5)
            setSpace(15)
        }
        else{
            setCol(3);
            setSpace(10);
        }
    },[])

    return {col,space};
}

export default useGroup